import type { Except } from "type-fest";
import type { Pagination } from "./pagination";

type QueryResponse<Data> = {
    _type: "QUERY_RESPONSE";
    etag?: string;
    data: Data;
    pagination?: Pagination;
};

type FactoryParams<Data> = Except<
    QueryResponse<Data>,
    "_type" | "etag" | "pagination"
> & {
    etag?: string;
    pagination?: Pagination;
};

function queryResponseFactory<Data>(
    params: FactoryParams<Data>,
): QueryResponse<Data> {
    return {
        _type: "QUERY_RESPONSE",
        etag: params.etag,
        data: params.data,
        pagination: params.pagination,
    };
}

export { queryResponseFactory };
export type { QueryResponse };
